import { render } from "./TagboardList.vue?vue&type=template&id=940f093a"
import script from "./TagboardList.vue?vue&type=script&lang=js"
export * from "./TagboardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__